export const headerWidgetAreaId = 'header-widget-area';
